import React from 'react';
import { FormattedMessage } from 'react-intl';
import paybygroupSteel from '../img/keytravel-steel.png';

const merchantLogo = (props) => {
  const { displayName, logoUrl } = props;
  if (logoUrl) {
    return <img alt={displayName} className="merchant-logo" src={logoUrl} />;
  }
  return null;
};

export default function (props) {
  const pbgLogo = props.pbgLogo || paybygroupSteel;

  return (
    <div className="purchase-summary-merchant-logo text-center">
      {merchantLogo(props)}
      <p className="small-print">
        <span className="powered">
          <FormattedMessage
            id="footerPoweredBy.poweredBy"
            defaultMessage="powered by{logo}"
            values={{
              logo: <img src={pbgLogo} alt="Key Travel" className="paybygroup-powered" />,
            }}
          />
        </span>
      </p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/desktop/components/footer-powered-by.js